import { EditorUtils, ProseMirror } from "@progress/kendo-react-editor";

const { EditorView, EditorState } = ProseMirror;
const { tableResizing, imageResizing } = EditorUtils;

/**
 * Set up ProseMirror EditorView with custom configuration
 * @param {Object} event - The mount event from Kendo Editor
 * @param {Object} mySchema - The custom schema for the editor
 * @param {Object} viewProps - Additional view properties
 * @param {Object} eventHandlers - Custom event handlers
 * @returns {EditorView} - The configured EditorView instance
 */
export const setUpEditorView = (event, mySchema, viewProps = {}, eventHandlers = {}) => {
  const doc = EditorUtils.createDocument(mySchema, viewProps.value || "<p></p>");

  return new EditorView(
    { mount: event.dom },
    {
      ...event.viewProps,
      handleDOMEvents: {
        ...event.viewProps.handleDOMEvents,
        ...eventHandlers,
      },
      state: EditorState.create({
        doc,
        plugins: [...tableResizing(), imageResizing(), ...event.viewProps.state.plugins],
      }),
    }
  );
};

/**
 * Create editor event handlers with custom logic
 * @param {Object} existingHandlers - Existing event handlers from Kendo
 * @returns {Object} - Combined event handlers
 */
export const createEditorEventHandlers = (existingHandlers = {}) => ({
  ...existingHandlers,
  // Add custom event handlers here if needed
});

export default {
  setUpEditorView,
  createEditorEventHandlers,
};
